import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCheckCircleFillComponent } from "./med-icon-check-circle-fill.component";

@NgModule({
  declarations: [
    MedIconCheckCircleFillComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCheckCircleFillComponent,
  ],
})
export class MedIconCheckCircleFillModule { }
